import type { infer as zInfer } from "zod";
import { number, object } from "zod";

export const getKatanaIntegration = {
  name: "getKatanaIntegration" as const,
  input: object({}),
  output: object({
    katanaIntegration: object({ restockLocationId: number() }).optional(),
  }),
};

export type KatanaIntegration = zInfer<typeof getKatanaIntegration.output>;
